import { CryptoProps } from '../types';
import OldSecurityCrypto from './old';
import NewSecurityCrypto from './new';
import { BaseSecurityCrypto } from './base';
import { debug } from '@byted/tiktok-zti-utils';

const notSupportedUA = [
  'Android',
  'Linux',
  'YaBrowser',
  'Firefox',
  'X11',
  'PlayStation',
  'Windows NT 6',
  'iPhone',
  'Edg',
  'OPR',
  'Avast'
];

let isSupported =
  window.isSecureContext &&
  window.crypto &&
  window.crypto.subtle &&
  window.TextEncoder &&
  window.TextDecoder &&
  Boolean(window?.crypto?.subtle?.generateKey) &&
  Boolean(window?.crypto?.subtle?.sign) &&
  Boolean(window?.crypto?.subtle?.exportKey) &&
  Boolean(window?.crypto?.subtle?.importKey);

if (isSupported && window.navigator.userAgent) {
  notSupportedUA.forEach((x) => {
    if (window.navigator.userAgent.includes(x)) {
      isSupported = false;
    }
  });
}

const sleep = (ms: number) =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, ms);
  });

class SecurityCrypto {
  type = 'jsrsasign';
  private item: BaseSecurityCrypto;
  constructor(props: CryptoProps) {
    if (isSupported) {
      this.type = 'crypto';
      this.item = new NewSecurityCrypto(props);
    } else {
      this.type = 'jsrsasign';
      this.item = new OldSecurityCrypto(props);
    }
  }

  /**
   * 获取当前keys
   * @returns  privateKey & publickKey
   */
  getKeys = async (n = 1): Promise<ReturnType<BaseSecurityCrypto['getKeys']>> => {
    if (this.type === 'crypto') {
      const keys = this.item.getKeys();
      if (keys.privateKey && keys.publicKey) {
        debug('get keys with crypto tryied', n - 1);
        return keys;
      } else {
        if (n < 100) {
          await sleep(10);
          return this.getKeys(n + 1);
        } else {
          this.type = 'jsrsasign';
          this.item = new OldSecurityCrypto({});
          debug('change to jsrsasign due to crypto get keys delay');
          return this.item.getKeys();
        }
      }
    } else {
      return this.item.getKeys();
    }
  };

  /**
   * sign 加签数据
   * @param sign_str string  需要加签的数据
   * @returns string 加签之后的数据
   */
  sign = (sign_str: string) => this.item.sign(sign_str);
}

export default SecurityCrypto;
